export const WORKSPACE_LOGIN_CONFIG_KEY_BASE = 'workspace-login-config';
export const WorkspaceLoginConfigKeyFactory = {
    all: () => [WORKSPACE_LOGIN_CONFIG_KEY_BASE],
    byName: (workspaceName) => [
        ...WorkspaceLoginConfigKeyFactory.all(),
        workspaceName,
    ],
};
